module.exports = __webpack_public_path__ + "static/img/logo@2x.a39d875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo@2x.png
// module id = YyXG
// module chunks = 31